import React, { useEffect, useState } from 'react';
import { Link, Navigate, Outlet, useParams } from 'react-router-dom';
import { UNIT_NAV_BADGE } from '../constants/unitsMeta';
import { api } from '../utils/api';

const UNITS = ['mp', 'cid', 'qrf'];

export default function UnitLayout() {
  const { unit } = useParams();
  const [canAccessCurrentUnit, setCanAccessCurrentUnit] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await api.get(`/api-me?unit=${unit}`);
        if (!cancelled) setCanAccessCurrentUnit(true);
      } catch (err) {
        if (!cancelled) {
          if (err.status === 403 && unit !== 'mp') {
            setCanAccessCurrentUnit(false);
          } else {
            setCanAccessCurrentUnit(true);
          }
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [unit]);

  if (!UNITS.includes(unit)) {
    return <Navigate to="/jednostki" replace />;
  }
  if (canAccessCurrentUnit === null) {
    return <div className="loading">Ładowanie...</div>;
  }
  if (canAccessCurrentUnit === false) {
    return <Navigate to="/mp/dashboard" replace />;
  }
  return (
    <div className="unit-shell">
      <div className="unit-switch-bar" role="navigation" aria-label="Nawigacja jednostki">
        <div className="unit-switch-bar__inner">
          <Link to="/jednostki" className="unit-switch-bar__link">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
            Wybór jednostki
          </Link>
          <span className="unit-switch-bar__badge">{UNIT_NAV_BADGE[unit] || unit.toUpperCase()}</span>
        </div>
      </div>
      <Outlet context={{ unit }} />
    </div>
  );
}
